module.exports = __webpack_public_path__ + "static/teaser_technologien-d2024bc9b7063f1055d35897b575c9ba.svg";